import React, { useEffect } from 'react';
import { CompanyLogo, LoadingOverlay } from '@/Components/shared';
import AccountCreationForm from '@/Components/AccountCreation/AccountCreationForm';
import MeshBackgroundCenterOverlay from '@/Components/layouts/MeshBackroundCenterOverlay';
import { Card, CardContent, CardHeader, CardTitle } from '@/Components/shadcn';
import { useUserContext } from '@/Context/UserContext';
import UIStrings from '@/Utils/UIStrings';
import useAcceptInvitationState from './Hooks/useAcceptInvitationState';

function AcceptInvitationPage() {
    const { companyName, isLoading, allowAccountSetup, isSubmitting, submitHandler, isError } =
        useAcceptInvitationState();
    const { user } = useUserContext();

    useEffect(() => {
        if (!allowAccountSetup) {
            const { firstName, lastName } = user;
            submitHandler({ firstName, lastName, companyName });
        }
    }, [allowAccountSetup]);

    if (isLoading || !allowAccountSetup) {
        return <LoadingOverlay />;
    }

    return (
        <MeshBackgroundCenterOverlay>
            <CompanyLogo
                width={195}
                height={37.5}
                color="primary"
                className="mb-8 shrink-0"
                aria-label={UIStrings.CompanyLogo}
            />
            <Card className="border-border w-full overflow-hidden rounded-2xl border drop-shadow-xl">
                <CardHeader className="px-6 py-6">
                    <CardTitle className="text-foreground text-xl font-semibold tracking-tight md:text-2xl">
                        {UIStrings.SetupYourProfile}
                    </CardTitle>
                </CardHeader>
                <CardContent className="px-6">
                    <AccountCreationForm
                        initialFirstName={user.firstName || ''}
                        initialLastName={user.lastName || ''}
                        initialCompanyName={companyName}
                        isSubmitting={isSubmitting}
                        submitHandler={submitHandler}
                        isError={isError}
                    />
                </CardContent>
            </Card>
        </MeshBackgroundCenterOverlay>
    );
}

export default AcceptInvitationPage;
